import { createContext, FC, ReactNode, useContext } from "react";
import { useLiveAPI, UseLiveAPIResults } from "../hooks/use-live-api";
const LiveAPIContext = createContext<UseLiveAPIResults | undefined>(undefined);
export type LiveAPIProviderProps = {
children: ReactNode;
url?: string;
apiKey: string;
};
export const LiveAPIProvider: FC<LiveAPIProviderProps> = ({
url,
apiKey,
children,
}) => {
const liveAPI = useLiveAPI({ url, apiKey });
return (
<LiveAPIContext.Provider value={liveAPI}>
{children}
</LiveAPIContext.Provider>
);
};
export const useLiveAPIContext = () => {
const context = useContext(LiveAPIContext);
if (!context) {
throw new Error("useLiveAPIContext must be used wihin a LiveAPIProvider");
}
return context;
};
